module.exports = __webpack_public_path__ + "img/HQ-PA10W1UH-T.87162484.jpg";